var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiteLinksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.9998L15 8.99982M11 5.99982L11.463 5.46382C12.4008 4.52614 13.6727 3.99942 14.9989 3.99951C16.325 3.99961 17.5968 4.52651 18.5345 5.46432C19.4722 6.40212 19.9989 7.67401 19.9988 9.00017C19.9987 10.3263 19.4718 11.5981 18.534 12.5358L18 12.9998M13 17.9998L12.603 18.5338C11.6543 19.472 10.3738 19.9982 9.03952 19.9982C7.70523 19.9982 6.42477 19.472 5.47602 18.5338C5.00838 18.0714 4.63711 17.5208 4.38373 16.914C4.13035 16.3071 3.99988 15.656 3.99988 14.9983C3.99988 14.3407 4.13035 13.6896 4.38373 13.0827C4.63711 12.4758 5.00838 11.9252 5.47602 11.4628L6.00002 10.9998",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteLinksIcon);
export default __webpack_public_path__ + "static/media/SiteLinksIcon.9e8f00bb3fb99bcde22ae7317dadf18b.svg";
export { ForwardRef as ReactComponent };